import { FilterTabs } from "./lib";

export const FilterTabLabelMapping: Record<FilterTabs, string> = {
    [FilterTabs.CATEGORY]: "Category",
    [FilterTabs.DATE]: "Date",
    [FilterTabs.AMOUNT]: "Amount",
    [FilterTabs.ACCOUNT]: "Account",
    [FilterTabs.RULES]: "Rules",
    [FilterTabs.SIMILAR_TO]: "Similar to",
    [FilterTabs.CLASS]: "Class",
    [FilterTabs.NOTE]: "Memo",
    [FilterTabs.RECEIPTS]: "Receipts",
    [FilterTabs.MATCHED]: "Match",
    [FilterTabs.SPLIT]: "Split",
    [FilterTabs.RECONCILIATION]: "Reconciliation",
    [FilterTabs.CASH_ITEM_TYPE]: "Check or deposit",
    [FilterTabs.COUNTERPARTY]: "Counterparty",
    [FilterTabs.COUNTERPARTY_CREATED_BY]: "Created by",
    [FilterTabs.CUSTOMER]: "Billable customer",
    [FilterTabs.DOCUMENT_STATUS]: "Status",
    [FilterTabs.DOCUMENT_CATEGORY]: "Category",
    [FilterTabs.ACCOUNT_CODE]: "General ledger",
    [FilterTabs.ACCOUNT_STATUS]: "Status",
    [FilterTabs.INVOICE_STATUSES]: "Kick status",
    [FilterTabs.EXTERNAL_INVOICE_STATUSES]: "External status",
    [FilterTabs.BILLABLE_EXPENSE_INVOICE_STATUSES]: "Billable invoice status",
    [FilterTabs.CATALOG_ITEM]: "Catalog item",
    [FilterTabs.INVOICE_SOURCE_TEMPLATE]: "Template",
    [FilterTabs.CATALOG_ITEM_INCOME_ACCOUNT]: "Income account",
    [FilterTabs.CATALOG_ITEM_RECEIVABLES_ACCOUNT]: "Receivables account",
    [FilterTabs.SUBSCRIPTION]: "Subscription",
    [FilterTabs.BILL_STATUSES]: "Status",
    [FilterTabs.EXTERNAL_BILL_STATUSES]: "External status",
    [FilterTabs.OVERDUE]: "Due date",
    [FilterTabs.DUE]: "Due",
    [FilterTabs.RULES_STATUS]: "Rules status",
    [FilterTabs.RULES_SOURCE]: "Source",
    [FilterTabs.RULES_ACTION]: "Actions",
    [FilterTabs.LEDGER]: "General ledger",
    [FilterTabs.CASH_GENERAL_LEDGER]: "Cash ledger",
    [FilterTabs.ACCRUAL_GENERAL_LEDGER]: "Accrual ledger",
    [FilterTabs.ACCRUAL_LEDGER]: "Accrual ledger",
    [FilterTabs.TRANSACTION_IDS]: "Transactions",
    [FilterTabs.PLANS]: "Plan",
    [FilterTabs.WHO_PAYS]: "Who pays",
    [FilterTabs.SERVICES]: "Practices",
    [FilterTabs.TEAM_MEMBERS]: "Team",
    [FilterTabs.ASSIGNEE]: "Assigned",
    [FilterTabs.LEGAL_TYPE]: "Entity type",
    [FilterTabs.ENTITY_INDUSTRY]: "Industry",
    [FilterTabs.ENTITY_BASIS]: "Basis",
    [FilterTabs.START_DATE]: "Start date",
    [FilterTabs.CLOSE_STAGE]: "Stage",
    [FilterTabs.PRIORITY]: "Priority",
    [FilterTabs.CLOSE_DATE]: "Service period",
    [FilterTabs.DUE_DATE]: "Due date",
    [FilterTabs.TRANSACTION_LOCKED]: "Locked",
    [FilterTabs.ACCOUNT_SOURCE]: "Source",
    [FilterTabs.ACCOUNT_ROLE_PRESENCE]: "System role",
    [FilterTabs.ACCOUNT_RULE_PRESENCE]: "Rules",
    [FilterTabs.FORM_1099_BOX]: "1099 box",
    [FilterTabs.COA_TEMPLATE_GROUPS]: "Groups",
    [FilterTabs.JOURNAL_ENTRY_SOURCES]: "Entry source",
    [FilterTabs.UNREAD]: "Unread tasks",
    [FilterTabs.DOCUMENT_PERIOD]: "Period",
    [FilterTabs.UPLOADER]: "Uploaded by",
    [FilterTabs.UPLOAD_DATE]: "Upload date",
    [FilterTabs.DOCUMENT_TYPE]: "File type",
    [FilterTabs.STATUS]: "Status",
    [FilterTabs.MATCH_STATUS]: "Match",
    [FilterTabs.AUDIT_LOG]: "Audit log",
    [FilterTabs.BILL_IDS]: "Bills",
    [FilterTabs.INVOICE_IDS]: "Invoices",
    [FilterTabs.TEMPLATE_COUNTERPARTY]: "Counterparty",
    [FilterTabs.TEMPLATE_CUSTOMER]: "Billable customer",
    [FilterTabs.TEMPLATE_CLASS]: "Class",
    [FilterTabs.TEMPLATE_BASIS]: "Basis",
    [FilterTabs.TEMPLATE_LAST_EDITED_BY]: "Last edited by",
    [FilterTabs.TEMPLATE_OWNER]: "Owner",
    [FilterTabs.TEMPLATE_CREATED_BY]: "Created by",
    [FilterTabs.TEMPLATE_TYPE]: "Type",
    [FilterTabs.TEMPLATE_IDS]: "Templates",
    [FilterTabs.TASK_ASSIGNEE]: "Assignee",
    [FilterTabs.TASK_CREATED_BY]: "Created by",
    [FilterTabs.TASK_CLIENT]: "Client",
    [FilterTabs.TASK_CREATED_ON]: "Created on",
    [FilterTabs.TASK_COMPLETED_BY]: "Completed by",
    [FilterTabs.TASK_COMPLETED_ON]: "Completed on",
    [FilterTabs.TASK_CLOSE]: "Service",
    [FilterTabs.TASK_PRIORITY]: "Priority",
    [FilterTabs.TASK_ATTACHMENTS]: "Attachments",
    [FilterTabs.TASK_GROUP]: "Task group",
    [FilterTabs.TASK_DEPENDENCIES]: "Dependencies",
    [FilterTabs.TASK_CHAT]: "Chat",
    [FilterTabs.TASK_STAGE]: "Stage",
    [FilterTabs.ORG_TASK_TEMPLATE_TYPE]: "Workflow",
    [FilterTabs.ORG_TASK_TEMPLATE_GROUP]: "Task group",
    [FilterTabs.ORG_TASK_TEMPLATE_ASSIGNEE_ROLE]: "Role",
    [FilterTabs.ORG_TASK_TEMPLATE_CREATED_BY]: "Created by",
    [FilterTabs.ORG_CLOSE_STAGE]: "Stage",
    [FilterTabs.CLOSE_STATUS]: "Status",
    [FilterTabs.ORG_SERVICE]: "Tier",
    [FilterTabs.CLOSE_TEMPLATE]: "Service template",
    [FilterTabs.APPLICATION_TYPE]: "Application type",
    [FilterTabs.PROGRESS]: "Progress",
    [FilterTabs.HEALTH]: "Health",
    [FilterTabs.WORK_CLIENT]: "Client",
    [FilterTabs.WORK_START_DATE]: "Work start date",
    [FilterTabs.WORK_DELIVERY_DATE]: "Work end date",
    [FilterTabs.APPLICATION_DATE]: "Application date",
    [FilterTabs.COA_LAST_UPDATED]: "Updated on",
    [FilterTabs.COA_APPLIED_AT]: "Applied",
    [FilterTabs.DAYS_IN_STAGE]: "Days in stage",
    [FilterTabs.REVIEW]: "Review",
    [FilterTabs.RULES_REVIEW]: "Review",
    [FilterTabs.COUNTERPARTY_REVIEW]: "Review",
    [FilterTabs.COUNTERPARTY_DISABLED]: "Disabled",
    [FilterTabs.ENGAGEMENT_TEAM]: "Engagement team",
    [FilterTabs.ELIGIBLE_1099]: "1099",
    [FilterTabs.EXCLUDE_1099]: "1099",
    [FilterTabs.LEDGER_GROUP]: "Ledger type",
    [FilterTabs.SCHEDULE_PERIOD]: "Period",
    [FilterTabs.SCHEDULE_TEMPLATE]: "Service",
    [FilterTabs.SCHEDULE_CLIENT]: "Client",
    [FilterTabs.SCHEDULES_REPORT_TEMPLATE]: "Schedule",
    [FilterTabs.SCHEDULES_REPORT_GROUP]: "Group",
    [FilterTabs.HOLDING_ACCOUNT]: "Account",
    [FilterTabs.TERM_START]: "Term start",
    [FilterTabs.TERM_END]: "Term end",
    [FilterTabs.INVOICE_TERMS]: "Terms",
    [FilterTabs.INVOICE_SENT_STATUS]: "Sent",
    [FilterTabs.INVOICE_CREATED_ON]: "Created on",
    [FilterTabs.INVOICE_DUE_DATE]: "Due date",
    [FilterTabs.INVOICE_DATE]: "Invoice date",
    [FilterTabs.AGING_PERIOD]: "Aging period",
    [FilterTabs.DRAFT_SOURCE]: "Source",
    [FilterTabs.DRAFT_COUNTERPARTY]: "Counterparty",
    [FilterTabs.DRAFT_DUE_DATE]: "Due date",
    [FilterTabs.DRAFT_STATUS]: "Status",
};

interface FilterTabLabelOverrides {
    counterpartyEntityLabel?: string;
    ledgerFilterLabel?: string;
    tabLabels?: Partial<Record<FilterTabs, string>>;
}

export function getFilterTabLabel(
    filterTab: FilterTabs,
    overrides: FilterTabLabelOverrides = {},
): string {
    const tabLabel = overrides.tabLabels?.[filterTab];
    if (tabLabel) {
        return tabLabel;
    }

    if (
        filterTab === FilterTabs.COUNTERPARTY &&
        overrides.counterpartyEntityLabel
    ) {
        return overrides.counterpartyEntityLabel;
    }

    if (filterTab === FilterTabs.LEDGER && overrides.ledgerFilterLabel) {
        return overrides.ledgerFilterLabel;
    }

    return FilterTabLabelMapping[filterTab];
}
